module.exports = __webpack_public_path__ + "images/icons_v2/values-mission-first-3fbefbe6.svg";